import React, { Component } from "react";
import withRouter from "../../../withRouter/withRouter";

import WriteMessage from "../WriteMessage/WriteMessage";


import "./NewTicket.css";

class NewTicket extends Component {
    constructor(props) {
        super(props);

        this.send = this.send.bind(this);
    }

    componentDidMount() {
        let { connection, toast } = this.props;

        connection
            .get_orders("all")
            .then((res) => {
                this.setState({ orders: res.data.orders });
            })
            .catch((err) => {
                toast("دریافت سفارشات", "خطا در دریافت سفارش ها", " danger");
            });
    }

    send(message, attachments) {
        let { connection, toast, router } = this.props;

        connection
            .new_ticket({
                subject: this.state.selecetedOrder || "other",
                messages: [
                    {
                        poster: "costumer",
                        message: message,
                        attachments: attachments,
                        time: Date.now(),
                    },
                ],
            })
            .then((res) => {
                toast(
                    "درخواست پشتیبانی",
                    " درخواست پشتیبانی با موفقیت ارسال شد. مدیر سایت در اسرع وقت به آن پاسخ خواهد داد.",
                    " confirm"
                );
                router.navigate("/costumer/support");
            })
            .catch((err) => {
                toast(
                    "درخواست پشتیبانی",
                    " خطا در ثبت درخواست پشتیبانی" + err,
                    " danger"
                );
            });
    }

    state = {
        subjectSelect: "order",
        selecetedOrder: null,
        orders: null,
        attachments: null,
        dialog: null,
    };

    render() {
        let { subjectSelect, selecetedOrder, orders, attachments, dialog } =
            this.state;
        let { toast, connection } = this.props;
        return (
            <div className="NewTicketComponent">
                {dialog}
                <div className="NewTicketContainer">
                    <div className="subject">
                        <div className="caption text info">
                            موضوع را انتخاب کنید:
                        </div>
                        <div className="select">
                            <div
                                className={
                                    "order " +
                                    (subjectSelect === "order" && "selected")
                                }
                            >
                                مربوط به سفارش
                            </div>
                            <div className="input">
                                <input
                                    type="checkbox"
                                    defaultChecked={subjectSelect === "order"}
                                    onChange={(ev) => {
                                        this.setState({
                                            subjectSelect: ev.target.checked
                                                ? "order"
                                                : "other",
                                        });
                                    }}
                                />
                            </div>

                            <div
                                className={
                                    "other " +
                                    (subjectSelect === "other" && "selected")
                                }
                            >
                                متفرقه
                            </div>
                        </div>

                        {subjectSelect === "order" && (
                            <select
                                defaultValue={-1}
                                onChange={(ev) =>
                                    this.setState({
                                        selecetedOrder: ev.target.value,
                                    })
                                }
                            >
                                <option value="-1" disabled>
                                    {" "}
                                    سفارش مورد نظر را انتخاب کنید
                                </option>
                                {orders &&
                                    orders.map((order) => {
                                        return (
                                            <option
                                                value={order.id}
                                                key={order.id}
                                            >
                                                سفارش شماره
                                                {order.id}
                                                {" ----- "}
                                                {order.items &&
                                                    order.items
                                                        .map((item) => {
                                                            return item.name;
                                                        })
                                                        .join(" | ")}
                                            </option>
                                        );
                                    })}
                            </select>
                        )}
                    </div>

                    <WriteMessage
                        toast={toast}
                        connection={connection}
                        send={this.send}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(NewTicket);
